import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import edit from './edit';
import save from './save';
import SingleBlockData from './block.json';
import attributeVisibility from '@components/visibility/attributes.json'; // eslint-disable-line
import { getBlockLabelByName } from '@helpers/utils';
import singlePostIcon from './icons';

const { name, ...settings } = SingleBlockData;

const attributes = {
  ...attributeVisibility,
  ...settings.attributes,
};

registerBlockType(name, {
  ...settings,
  icon: singlePostIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
